const ordenInitialState = {
  orden: {
    data: [],
    loading: false,
    error: false,
    estado: null,
  },
};

export default ordenInitialState;
